import { APIHandler } from "../base";

export const fetchUser = () => APIHandler.get("/users/current");

export const updateUser = (firebaseId: string) =>
    APIHandler.patch("/users/current", { firebaseId });
